export default "__VITE_ASSET__BWZS6tf7__"